import React, { forwardRef, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import Loading from 'components/Loading';
import styles from './LoadOnScroll.module.scss';

const BOTTOM_OFFSET = 350;

const loadOnScrollRender = ({ children, fetchMore, hasMore, fetching, className }, ref) => {
  const lastValue = useRef(null);
  const listContainer = ref || useRef(null);
  const { current: throttledFetch } = useRef(
    throttle(fetchMore, 1000, { leading: true, trailing: false }),
  );
  const onScroll = useCallback(() => {
    const {
      current: { clientHeight, scrollTop, scrollHeight },
    } = listContainer;

    if (
      !fetching &&
      hasMore &&
      scrollTop > lastValue.current &&
      scrollTop + clientHeight >= scrollHeight - BOTTOM_OFFSET
    ) {
      throttledFetch();
    }

    lastValue.current = scrollTop;
  }, [fetching, hasMore]);

  return (
    <div className={`${styles.scroller} ${className}`} ref={listContainer} onScroll={onScroll}>
      {children}
      {fetching && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}

      <div className={styles.actionsContainer}>
        {!fetching && hasMore && (
          <div className={styles.actions}>
            <span onClick={fetchMore} className={styles.showMore}>
              Показать еще
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

const LoadOnScroll = forwardRef(loadOnScrollRender);

LoadOnScroll.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  fetchMore: PropTypes.func.isRequired,
  hasMore: PropTypes.bool,
  fetching: PropTypes.bool,
  className: PropTypes.string,
};

LoadOnScroll.defaultProps = {
  className: '',
};

export default LoadOnScroll;
